import React from "react";
import LegalLayout from "../components/LegalLayout";

const Section = ({ id, title, children }) => (
  <section id={id}>
    <h2 className="font-serif text-2xl md:text-3xl text-white mb-4">{title}</h2>
    <div className="space-y-3 text-white/75">{children}</div>
  </section>
);

const Villkor = () => (
  <div data-testid="page-villkor">
    <LegalLayout
      eyebrow="Villkor"
      title="Användarvillkor"
      updated="2026-07-05"
    >
      <p>
        Dessa användarvillkor gäller för webbplatsen{" "}
        <strong>orkesteradmin.se</strong> (”landningssidan”) som drivs av
        Redoc AB. Genom att använda landningssidan godkänner du dessa villkor.
      </p>

      <Section id="tjansten" title="1. Om landningssidan">
        <p>
          Landningssidan är en informativ presentation av tjänsten Orkesteradmin
          – ett webbaserat system för administration av orkestrar. Du kan här
          läsa om funktioner, se pris, kontakta oss och beställa via extern
          betallänk. Själva tjänsten Orkesteradmin regleras av separata
          avtalsvillkor som du får ta del av i samband med beställning.
        </p>
      </Section>

      <Section id="anvandning" title="2. Tillåten användning">
        <p>
          Du får använda landningssidan för att inhämta information, ta kontakt
          med oss och genomföra beställning. Du får inte:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>använda automatiserade verktyg för att belasta sidan,</li>
          <li>försöka få obehörig åtkomst till system, servrar eller data,</li>
          <li>skicka in olagligt, kränkande eller vilseledande innehåll via kontaktformuläret,</li>
          <li>använda innehållet i kommersiella syften utan skriftligt medgivande.</li>
        </ul>
      </Section>

      <Section id="innehall" title="3. Innehåll och immateriella rättigheter">
        <p>
          Allt innehåll på landningssidan – text, bilder, logotyper, layout och
          källkod – tillhör Redoc AB eller respektive rättighetsinnehavare och
          skyddas av upphovsrätt och andra immaterialrättsliga lagar.
          Återgivning eller vidareanvändning kräver skriftligt tillstånd.
        </p>
      </Section>

      <Section id="lankar" title="4. Externa länkar och tjänster">
        <p>
          Landningssidan kan innehålla länkar till externa webbplatser (t.ex.
          STIM, Musikerförbundet, Skatteverket samt Stripe för betalning). Vi
          ansvarar inte för innehåll, tillgänglighet eller integritetsrutiner
          på webbplatser som drivs av tredje part.
        </p>
      </Section>

      <Section id="ansvarsbegransning" title="5. Ansvarsbegränsning">
        <p>
          Informationen på landningssidan tillhandahålls i befintligt skick. Vi
          strävar efter att uppgifterna ska vara korrekta och uppdaterade men
          lämnar inga garantier avseende fullständighet eller lämplighet för ett
          visst syfte. Redoc AB ansvarar inte för indirekta skador eller
          följdskador som uppstår vid användning av landningssidan.
        </p>
      </Section>

      <Section id="andringar" title="6. Ändringar av villkoren">
        <p>
          Vi kan komma att uppdatera dessa villkor. Den senaste versionen
          publiceras alltid här med datumet för uppdatering.
        </p>
      </Section>

      <Section id="lag" title="7. Tillämplig lag och tvist">
        <p>
          Dessa villkor lyder under svensk rätt. Tvist ska i första hand lösas i
          samförstånd. Om detta inte är möjligt ska tvisten avgöras av allmän
          svensk domstol.
        </p>
      </Section>

      <Section id="kontakt" title="8. Kontakt">
        <p>
          Frågor om villkoren skickas till{" "}
          <span className="text-white">kontakt.orkesteradmin@gmail.com</span>{" "}
          eller via kontaktformuläret på startsidan.
        </p>
      </Section>
    </LegalLayout>
  </div>
);

export default Villkor;
